/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";


const BuildServers = function (buildServerId) {


    async function listAll() {
        return callWSFunction("buildserver.listAll", {})
    }

    async function getInfo() {
        return callWSFunction("buildserver.getInfo", {
            buildServerId: buildServerId
        })
    }

    async function remove() {
        return callWSFunction("buildserver.remove", {
            buildServerId: buildServerId
        })
    }

    async function getLogs() {
        return callWSFunction("buildserver.getLogs", {
            buildServerId: buildServerId
        })
    }

    return {
        listAll,
        getInfo,
        remove,
        getLogs
    }
}

export {BuildServers}